export const useTooltipWithIcon = (text, icons) => {
  return text + ' <span class="text-primary">' + icons + "</span>";
};
